import { ArrowLeft } from "lucide-react";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { HelpChatPanel } from "@/components/layout/HelpChatPanel";
import { useHelp } from "@/components/layout/HelpProvider";
import { Button } from "@/components/ui/button";
import { Drawer, DrawerClose, DrawerContent, DrawerTitle } from "@/components/ui/drawer";
import { useIsMobile } from "@/hooks/useIsMobile";

export function HelpChatDrawer(): ReactElement | null {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const { chatOpen, closeChat } = useHelp();

  if (!isMobile) return null;

  return (
    <Drawer
      open={chatOpen}
      onOpenChange={(open) => {
        if (!open) closeChat();
      }}
    >
      <DrawerContent className="sm:max-w-md">
        <DrawerTitle className="sr-only">{t("help.chatTitle")}</DrawerTitle>
        <HelpChatPanel
          headerStart={
            <DrawerClose asChild>
              <Button type="button" variant="ghost" size="icon-sm" className="-ml-1 shrink-0">
                <ArrowLeft className="size-4" aria-hidden />
                <span className="sr-only">{t("common.back")}</span>
              </Button>
            </DrawerClose>
          }
        />
      </DrawerContent>
    </Drawer>
  );
}
